import { Container, Typography, Paper } from "@material-ui/core";

export default function TermsOfUse() {
  return (
    <Container maxWidth="sm">
      <Paper style={{ padding: 20, marginTop: 20 }}>
        <Typography variant="h5">Vilkår for brug</Typography>

        <Typography style={{ marginTop: 12 }}>
          Du må bruge platformen til lovlig brug og i overensstemmelse med
          almindelig god opførsel.
        </Typography>

        <Typography style={{ marginTop: 12 }}>
          Du er ansvarlig for din konto og det indhold, du opretter.
        </Typography>

        <Typography style={{ marginTop: 12 }}>
          Vi kan slette indhold eller konti ved misbrug.
        </Typography>

        <Typography style={{ marginTop: 12 }}>
          Kontakt: nbitecodeteam@gmail.com
        </Typography>
      </Paper>
    </Container>
  );
}